var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-up-wrapper choose-button"},[_c('span',{staticClass:"iconfont icon-paizhao"}),_c('input',{ref:"file",attrs:{"name":"file","type":"file","accept":"image/*"},on:{"change":_vm.onImageChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }